import React, { useState } from "react";
import { Modal, Button, notification } from "antd";
import FourthStep from "../create-legal-entity/rus-legal-entity/steps/fourth";
import { companyService } from "../../../services/company.services";

export default function ModalGuarantorBeforeContract({ visible, onClose, legalEntityId, country = 1, onSaved }) {
  const [fields, setFields] = useState({
    guarantorSecondName: "",
    guarantorFirstName: "",
    guarantorPatronymic: "",
    guarantorPassportSerial: "",
    guarantorPassportNumber: "",
    guarantorPassportDate: null,
    guarantorPassportDivision: "",
    guarantorPassportRegistration: "",
    guarantorPassportDivisionsList: [],
    // reg
    guarantorRegRegion: null,
    guarantorRegRegionsList: [],
    guarantorRegLocality: null,
    guarantorRegLocalitiesList: [],
    guarantorRegStreet: null,
    guarantorRegStreetsList: [],
    guarantorRegHouseNumber: null,
    guarantorRegHousesList: [],
    guarantorRegPremiseNumber: "",
    guarantorRegAddressPostalCode: "",
    // fact
    guarantorFactRegion: null,
    guarantorFactRegionsList: [],
    guarantorFactLocality: null,
    guarantorFactLocalitiesList: [],
    guarantorFactStreet: null,
    guarantorFactStreetsList: [],
    guarantorFactHouseNumber: null,
    guarantorFactHousesList: [],
    guarantorFactPremiseNumber: "",
    guarantorFactAddressPostalCode: "",
  });

  const getFieldErrors = () => null;

  const [sameAsReg, setSameAsReg] = useState(false);

  const handleSave = async () => {
    try {
      const current = await companyService.getLegalEntityData(legalEntityId);
      var legalName = "";
      if (current) {
        if (typeof current.name === "string") legalName = current.name;
        else if (typeof current.Name === "string") legalName = current.Name;
        else if (typeof current.legalName === "string") legalName = current.legalName;
        else if (typeof current.LegalName === "string") legalName = current.LegalName;
      }

      const getNameById = function(list, id) {
        if (!list || !list.length) return "";
        for (var i = 0; i < list.length; i++) {
          if (list[i] && (list[i].Id === id || list[i].id === id)) {
            return list[i].Name || list[i].name || "";
          }
        }
        return "";
      };

      var regAddressParts = [];
      var factAddressParts = [];
      var regRegionName = getNameById(fields.guarantorRegRegionsList, fields.guarantorRegRegion);
      var regLocalityName = getNameById(fields.guarantorRegLocalitiesList, fields.guarantorRegLocality);
      var regStreetName = getNameById(fields.guarantorRegStreetsList, fields.guarantorRegStreet);
      var regHouseName = getNameById(fields.guarantorRegHousesList, fields.guarantorRegHouseNumber);
      if (regRegionName) regAddressParts.push(regRegionName);
      if (regLocalityName) regAddressParts.push(regLocalityName);
      if (regStreetName) regAddressParts.push(regStreetName);
      if (regHouseName) regAddressParts.push(regHouseName);
      if (fields.guarantorRegPremiseNumber) regAddressParts.push(fields.guarantorRegPremiseNumber);
      var regAddressStr = regAddressParts.join(", ");

      var factRegionName, factLocalityName, factStreetName, factHouseName, factAddressStr;
      var sameAsRegFlag = !!fields.guarantorFactAddressCheckBox;
      if (sameAsRegFlag) {
        factRegionName = regRegionName;
        factLocalityName = regLocalityName;
        factStreetName = regStreetName;
        factHouseName = regHouseName;
        factAddressStr = regAddressStr;
      } else {
        factRegionName = getNameById(fields.guarantorFactRegionsList, fields.guarantorFactRegion);
        factLocalityName = getNameById(fields.guarantorFactLocalitiesList, fields.guarantorFactLocality);
        factStreetName = getNameById(fields.guarantorFactStreetsList, fields.guarantorFactStreet);
        factHouseName = getNameById(fields.guarantorFactHousesList, fields.guarantorFactHouseNumber);
        if (factRegionName) factAddressParts.push(factRegionName);
        if (factLocalityName) factAddressParts.push(factLocalityName);
        if (factStreetName) factAddressParts.push(factStreetName);
        if (factHouseName) factAddressParts.push(factHouseName);
        if (fields.guarantorFactPremiseNumber) factAddressParts.push(fields.guarantorFactPremiseNumber);
        factAddressStr = factAddressParts.join(", ");
      }

      if (!regAddressStr || !factAddressStr) {
        notification.error({
          message: "Проверьте адреса поручителя",
          description: "Заполните адрес регистрации и фактический адрес поручителя (регион, населенный пункт, улица, дом).",
        });
        return;
      }
      //const payload = Object.assign({}, current, {
      const payload = {
        name: legalName,
        guarantorSecondName: fields.guarantorSecondName,
        guarantorFirstName: fields.guarantorFirstName,
        guarantorPatronymic: fields.guarantorPatronymic,
        guarantorPassportSerial: fields.guarantorPassportSerial,
        guarantorPassportNumber: fields.guarantorPassportNumber,
        guarantorPassportDate:
          (fields.guarantorPassportDate && typeof fields.guarantorPassportDate.format === "function")
            ? fields.guarantorPassportDate.format("DD.MM.YYYY")
            : fields.guarantorPassportDate,
        guarantorPassportDivision: fields.guarantorPassportDivision,
        guarantorPassportRegistration: fields.guarantorPassportRegistration,
        guarantorRegRegion: fields.guarantorRegRegion,
        guarantorRegLocality: fields.guarantorRegLocality,
        guarantorRegStreet: fields.guarantorRegStreet,
        guarantorRegHouseNumber: fields.guarantorRegHouseNumber,
        guarantorRegPremiseNumber: fields.guarantorRegPremiseNumber,
        guarantorRegAddress: regAddressStr,
        guarantorRegAddressPostalCode: fields.guarantorRegAddressPostalCode,
        guarantorFactRegion: sameAsRegFlag ? fields.guarantorRegRegion : fields.guarantorFactRegion,
        guarantorFactLocality: sameAsRegFlag ? fields.guarantorRegLocality : fields.guarantorFactLocality,
        guarantorFactStreet: sameAsRegFlag ? fields.guarantorRegStreet : fields.guarantorFactStreet,
        guarantorFactHouseNumber: sameAsRegFlag ? fields.guarantorRegHouseNumber : fields.guarantorFactHouseNumber,
        guarantorFactPremiseNumber: sameAsRegFlag ? fields.guarantorRegPremiseNumber : fields.guarantorFactPremiseNumber,
        guarantorFactAddress: factAddressStr,
        guarantorFactAddressPostalCode: sameAsRegFlag ? fields.guarantorRegAddressPostalCode : fields.guarantorFactAddressPostalCode,
        guarantorFlag: 1, 
      };
      const resp = await companyService.editGuarantorLegalEntityData(payload, legalEntityId);
      if (resp.status === "success" || resp.code === 200) {
        notification.success({
          message: "Данные поручителя сохранены",
          description: resp.message || "",
        });
        if (onSaved) onSaved();
      } else {
        notification.error({
          message: "Ошибка сохранения поручителя",
          description: resp.message || "",
        });
      }
    } catch (e) {
      notification.error({
        message: "Ошибка сохранения поручителя",
        description: (e && typeof e.toString === 'function') ? e.toString() : '',
      });
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      title="Поручитель"
      width={1000}
      footer={[
        <Button key="close" onClick={onClose}>Закрыть</Button>,
        <Button key="save" type="primary" onClick={handleSave}>Сохранить</Button>,
      ]}
    >
      <FourthStep
        stepFields={fields}
        setFields={setFields}
        getFieldErrors={getFieldErrors}
        country={country}
        isProprietor={false}
      />
    </Modal>
  );
}
